export default "__VITE_ASSET__Bv9_hjjH__"